/** Panel admin: disparar tras cambios que afecten conteos (badges / resumen). */
export const ADMIN_OPS_REFRESH = 'javiland-admin-ops-refresh';
